import { FCWithChildren } from '@types';
import React from 'react';

import { Button } from '@components';
import { FaQuestionCircle } from 'react-icons/fa';
import { DeviceStatus } from '../../constants';

type ToolTipRightProps = {
  clickHandler?: () => void;
  type: string;
};

const ToolTipRight: FCWithChildren<ToolTipRightProps> = ({ clickHandler, type }) => {
  return [DeviceStatus.ACTIVE, DeviceStatus.ONLINE].includes(type) ? null : (
    <Button
      layout="link"
      onClick={clickHandler}
      className="absolute"
      style={{ padding: '5px 8px', marginTop: -5 }}
    >
      <FaQuestionCircle aria-hidden="true" />
      <span className="sr-only">Details</span>
    </Button>
  );
};

export default ToolTipRight;
